var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 46,
    viewBox: "0 0 92 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2279_5637)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2279_5637",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.7918 0H0.460938V45.3676H90.7918V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2279_5637)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2279_5637",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 13,
    width: 45,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2376 13.4688H23.6953V32.6082H67.2376V13.4688Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2279_5637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6953 13.4688V14.7782H32.1707V13.4688H23.6953ZM33.3716 13.4688V14.7782H45.4494C45.4494 14.7782 44.2157 13.4688 42.5818 13.4688H33.3716ZM47.8187 13.4688V14.7782H55.1256L54.692 13.4688H47.8187ZM60.3644 13.4688L59.9306 14.7782H67.1712V13.4688H60.3644ZM23.6953 16.0154V17.3249H32.1707V16.0154H23.6953ZM33.3716 16.0172V17.3249H46.8509C46.8509 17.3249 46.6935 16.317 46.4189 16.0172H33.3716ZM47.8187 16.0172V17.3249H55.9268L55.5254 16.0172H47.8187ZM59.4969 16.0172L59.0955 17.3249H67.1712V16.0172H59.4969ZM26.1309 18.562V19.8733H29.8014V18.562H26.1309ZM35.8072 18.562V19.8733H39.4777V18.562H35.8072ZM43.0478 18.562V19.8733H46.7182C46.7182 19.8733 46.9513 19.1807 46.9513 18.562H43.0478ZM50.2544 18.562V19.8733H56.7619L56.3282 18.562H50.2544ZM58.6975 18.562L58.2621 19.8733H64.802V18.562H58.6975ZM26.1309 21.1104V22.4199H29.8014V21.1104H26.1309ZM35.8072 21.1104V22.4199H45.1824C45.1824 22.4199 45.9666 21.748 46.2165 21.1104H35.8072ZM50.2544 21.1104V22.4199H53.9248V21.691L54.1579 22.4199H60.8815L61.1315 21.691V22.4199H64.802V21.1104H57.9117L57.546 22.2195L57.1786 21.1104H50.2544ZM26.1309 23.6571V24.9665H29.8014V23.6571H26.1309ZM35.8072 23.6571V24.9665H46.2165C45.9666 24.331 45.1824 23.6571 45.1824 23.6571H35.8072ZM50.2544 23.6571V24.9665H53.9248V23.6571H50.2544ZM54.5916 23.6571L55.0356 24.9665H60.0769L60.4987 23.6571H54.5916ZM61.1315 23.6571V24.9665H64.802V23.6571H61.1315ZM26.1309 26.2037V27.5132H29.8014V26.2037H26.1309ZM35.8072 26.2037V27.5132H39.4777V26.2037H35.8072ZM43.0478 26.2037V27.5132H46.9513C46.9513 26.8951 46.7182 26.2037 46.7182 26.2037H43.0478ZM50.2544 26.2037V27.5132H53.9248V26.2037H50.2544ZM55.4251 26.2037L55.8554 27.5132H59.235L59.6687 26.2037H55.4251ZM61.1315 26.2037V27.5132H64.802V26.2037H61.1315ZM23.7616 28.7503V30.0616H32.2371V28.7503H23.7616ZM33.3716 28.7503V30.0616H46.4189C46.6935 29.7613 46.8509 28.7503 46.8509 28.7503H33.3716ZM47.8851 28.7503V30.0616H53.9248V28.7503H47.8851ZM56.2601 28.7503L56.7024 30.0616H58.422L58.837 28.7503H56.2601ZM61.1315 28.7503V30.0616H67.2376V28.7503H61.1315ZM23.7616 31.2987V32.6082H32.2371V31.2987H23.7616ZM33.3716 31.2987V32.6064H42.5818C44.2157 32.6064 45.4495 31.2987 45.4495 31.2987H33.3716ZM47.8851 31.2987V32.6082H53.9248V31.2987H47.8851ZM57.0987 31.2987L57.5239 32.6046L57.5971 32.6064L58.0291 31.2987H57.0987ZM61.1315 31.2987V32.6082H67.2376V31.2987H61.1315Z",
    fill: "#1F2022"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2279_5637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 45.5882,
    fill: "white",
    transform: "translate(0.460938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbm);
export default __webpack_public_path__ + "static/media/ibm.b7496436052bb4d6c90a2b4a5c0b41ab.svg";
export { ForwardRef as ReactComponent };